import React from 'react';
import { Card } from '../ui/card';
import { ResponsiveContainer, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const KPITemporale = ({ bookings, filters }) => {
  const filterBookings = (bookingsList) => {
    return bookingsList.filter(booking => {
      const bookingDate = new Date(booking.booking_date);
      const bookingYear = bookingDate.getFullYear();
      const bookingMonth = bookingDate.getMonth() + 1;
      const bookingQuarter = Math.ceil(bookingMonth / 3);
      if (bookingYear !== filters.year) return false;
      if (filters.period === 'month' && filters.month) return bookingMonth === parseInt(filters.month);
      if (filters.period === 'quarter' && filters.quarter) return bookingQuarter === parseInt(filters.quarter);
      if (filters.propertyId && booking.property_id !== filters.propertyId) return false;
      return true;
    });
  };

  const currentBookings = filterBookings(bookings);

  const getBookingsByDate = () => {
    const grouped = {};
    currentBookings.forEach(booking => {
      const date = new Date(booking.booking_date).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
      if (!grouped[date]) {
        grouped[date] = { date, count: 0, revenue: 0 };
      }
      grouped[date].count++;
      grouped[date].revenue += booking.guest_total || 0;
    });
    return Object.values(grouped).sort((a, b) => {
      const [dayA, monthA] = a.date.split('/');
      const [dayB, monthB] = b.date.split('/');
      return monthA === monthB ? dayA - dayB : monthA - monthB;
    });
  };

  const bookingsByDate = getBookingsByDate();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">⏱️ Analisi Temporale</h2>
        <p className="text-gray-600">Trends e andamenti nel tempo</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">📅 Prenotazioni nel Tempo</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={bookingsByDate}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="count" stroke="#1e40af" name="Prenotazioni" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">💰 Ricavi nel Tempo</h3>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={bookingsByDate}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} />
              <YAxis />
              <Tooltip formatter={(value) => `€${value.toFixed(2)}`} />
              <Legend />
              <Area type="monotone" dataKey="revenue" stroke="#059669" fill="#059669" fillOpacity={0.3} name="Ricavi (€)" />
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
};

export default KPITemporale;